import { loginEventsMap } from "./login.event"
import { ClarityEventHandler } from "./clarityEventHandler"
import { signupEventsMap } from "./signup.event"

export class ClarityManager {
    private events: Map<HTMLElement | null, () => void> | undefined
    private routes = new Map([['/login', loginEventsMap], ['/signup', signupEventsMap]])

    constructor() {
        const path = window.location.pathname
        
        this.events = this.routes.get(path)?.()
    }
    
    init() {
        if(!this.events) return
        
        const clarityEvents = new ClarityEventHandler(this.events)
        clarityEvents.clickEvents()
    }
}
